// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : GOLD CLOSE LOAN SERVICE CREATED
// MODIFIED DATE: 23-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET GOLD LOAN MEMBER DETAILS START *********************** */
export const getGoldLoanMemberDetails = (listData: any) => {
	const data = {
		GetGoldLoanMemberDetailsToken: listData,
	};
	const url = `${API_URL}getGoldLoanMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET GOLD LOAN MEMBER DETAILS END *********************** */

/** ***************** UPDATE GOLD CLOSE DETAILS START *********************** */
export const updateGoldCloseDetails = (listData: any) => {
	const data = {
		UpdateGoldCloseDetailsToken: listData,
	};
	const url = `${API_URL}updateGoldCloseDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GOLD CLOSE DETAILS END *********************** */
